import { render, staticRenderFns } from "./SidebarSelectRow.vue?vue&type=template&id=b94b9674&scoped=true&"
import script from "./SidebarSelectRow.vue?vue&type=script&lang=js&"
export * from "./SidebarSelectRow.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSelectRow.vue?vue&type=style&index=0&id=b94b9674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b9674",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
